"use client";

// eslint-disable-next-line import/no-named-default
import { default as _dayjs } from "dayjs";
import localizedFormat from "dayjs/plugin/localizedFormat";

_dayjs.extend(localizedFormat);

const dayjs = _dayjs;

const loadDayjsLocale = async (locale: string) => {
  if (locale === "en") return; // already loaded by default
  await import(`dayjs/locale/${locale}.js`);
  dayjs.locale(locale);
};

export const setDayjsLocale = (locale: string) => {
  loadDayjsLocale(locale);
};

export default dayjs;
export { Dayjs } from "dayjs";
